module.exports = __webpack_public_path__ + "static/woaw-logo-38f73cd89ed0370600d3777e6cadd88e.png";